import { z } from "zod";
const schemaDeviceExchangeParams = z.object({
    apduHex: z.string(),
    transportId: z.string(),
});
const schemaDeviceExchangeResults = z.object({
    responseHex: z.string(),
});
export const schemaDeviceExchange = {
    params: schemaDeviceExchangeParams,
    result: schemaDeviceExchangeResults,
};
//# sourceMappingURL=DeviceExchange.js.map